<template>
	<div>
		<van-row type="flex" justify="space-between" class="step">
			<van-col class="box" :class="type>=1?'on':''">
				<van-icon class="icon" :name="type>=1?url[0]:urlon[0]" />
				<p>手机验证</p>
			</van-col>
			<van-col class="box" :class="type>=2?'on':''">
				<van-icon class="icon" :name="type>=2?url[1]:urlon[1]"  />
				<p>实名认证</p>
			</van-col>
			<van-col class="box" :class="type>=3?'on':''">
				<van-icon class="icon" :name="type>=3?url[2]:urlon[2]" />
				<p>提交申请</p>
			</van-col>
			<van-col class="box" :class="type>=4?'on':''">
				<van-icon class="icon" :name="type>=4?url[3]:urlon[3]" />
				<p>资料审核</p>
			</van-col>
			<van-col class="box" :class="type>=5?'on':''">
				<van-icon class="icon" :name="type>=5?url[4]:urlon[4]" />
				<p>缴费（如需）</p>
			</van-col>
			<van-col class="box" :class="type>=6?'on':''">
				<van-icon class="icon" :name="type>=6?url[5]:urlon[5]" />
				<p>开户成功</p>
			</van-col>
		</van-row>
	</div>
</template>

<script> 
	export default {
		name: 'setpbox',
		props:{
			type: { /* 步骤步数 */
				type: [Number, String],
				default:4
			},
		},
		data() {
			return {
				url:[
					require('../assets/images/kaihu/tu1.png'),
					require('../assets/images/kaihu/tu2.png'),
					require('../assets/images/kaihu/tu3.png'),
					require('../assets/images/kaihu/tu4.png'),
					require('../assets/images/kaihu/tu5.png'),
					require('../assets/images/kaihu/tu6.png'),
				],
				urlon:[
					require('../assets/images/kaihu/tu1on.png'),
					require('../assets/images/kaihu/tu2on.png'),
					require('../assets/images/kaihu/tu3on.png'),
					require('../assets/images/kaihu/tu4on.png'),
					require('../assets/images/kaihu/tu5on.png'),
					require('../assets/images/kaihu/tu6on.png'),
				],
			}
		},
		methods: {},
		mounted() {

		},

	}
</script>

<style lang="scss" scoped>
	.step {
		margin: 1rem -1.5rem;

		.box {
			font-size: 1.3rem;
			text-align: center;
			position: relative;
			flex: 1;

			&:first-child:before {
				display: none;
			}

			&:before {
				content: '';
				display: block;
				position: absolute;
				left: calc(0px - (100% - 3rem) / 2);
				width: calc(100% - 3rem);
				height: 1.8rem;
				background: url('../assets/images/service/step.png') no-repeat center;
				background-size: 100%;
			}

			.icon {
				font-size: 1.9rem;
				margin-bottom: 0.2rem;
			}
		}

		.box.on {
			color: #fa6b6b;

			&:before {
				background: url('../assets/images/service/step_on.png') no-repeat center;
				background-size: 100%;
			}
		}
	}
</style>
